// utils/requestColor.ts

export const getRequestTypeStyle = (requestType: string, request: any) => {
  switch (requestType) {
    case "Leave Application Form":
      return {
        text: request?.document?.leave_type || "Leave",
        color: "text-green-500",
      };
    case "Tardiness Application Form":
      return {
        text: "Tardiness",
        color: "text-blue-500",
      };
    case "Change DO Application Form":
      return {
        text: "Change Day Off",
        color: "text-cyan-500",
      };
    case "Change Shift Application Form":
      return {
        text: "Change Shift",
        color: "text-pink-500",
      };
    default:
      return {
        text: "Unknown",
        color: "text-gray-500",
      };
  }
};
